import React from 'react'
import "../FinalStep.css"
import finalImg from '../../../assets/images/car.png'


const FinalStep = () => {
  return (
    <div className='confirmation-step'>
        <div className='confirmation-title'>Payment failed!</div>
        <div className='confirmation-para'>
            Unfortunately, your payment could not be processed at this time.
            Please check your payment details or try again later.
        </div>
        <img src={finalImg} className='mt-4' />
    </div>
  )   
}

export default FinalStep
